import React from "react";
import VersionInfo from "../versioninfo/VersionInfo";

const Footer = () => (
    <div className="footer">
        <div className="version-info">
            <VersionInfo/>
        </div>
    </div>
);

export default Footer;